import fetch from 'cross-fetch';

// This will reject bad response codes (fetch by default doesn't)
const rejectingFetch = (...args) => fetch(...args).then(response => {
  if (response.ok) {
    return response;
  }
  throw response;
});

export default rejectingFetch;
